/**
 * Owner: Masa Bayu
 * File: discovery-from-catalog.ts
 * Date:Time: 2026-09-18 13:18
 * Description: PW-D / UI-06 discovery — facets · author filter · AuthorMatch.
 */

import {
  listAuthorMatches,
  searchMarketplaceCatalog,
  type QxreadAuthorMatch,
  type QxreadMarketplaceSearchOptions,
  type QxreadMarketplaceSearchResult,
  type QxreadMarketplaceSort,
} from '@qx/qxread-core';
import { listCatalog } from '../publication/catalog-port';

export type DiscoveryQuery = {
  readonly q?: string;
  readonly sort?: QxreadMarketplaceSort;
  readonly topicId?: string | null;
  readonly genreId?: string | null;
  readonly publicationTypeId?: string | null;
  readonly language?: string | null;
  readonly regionId?: string | null;
  readonly category?: string | null;
  readonly tag?: string | null;
  readonly author?: string | null;
};

function toSearchOptions(query: DiscoveryQuery): QxreadMarketplaceSearchOptions {
  return {
    ...(query.q !== undefined ? { q: query.q } : {}),
    ...(query.sort !== undefined ? { sort: query.sort } : {}),
    ...(query.topicId !== undefined ? { topicId: query.topicId } : {}),
    ...(query.genreId !== undefined ? { genreId: query.genreId } : {}),
    ...(query.publicationTypeId !== undefined
      ? { publicationTypeId: query.publicationTypeId }
      : {}),
    ...(query.language !== undefined ? { language: query.language } : {}),
    ...(query.regionId !== undefined ? { regionId: query.regionId } : {}),
    ...(query.category !== undefined ? { category: query.category } : {}),
    ...(query.tag !== undefined ? { tag: query.tag } : {}),
    ...(query.author !== undefined ? { author: query.author } : {}),
  };
}

/** Search/Discover over the active catalog port. Catalog ≠ entitlement. */
export function queryDiscoveryCatalog(
  query: DiscoveryQuery = {},
): QxreadMarketplaceSearchResult {
  return searchMarketplaceCatalog(listCatalog(), toSearchOptions(query));
}

/** Quiet author groups for Search — same catalog port. */
export function queryDiscoveryAuthorMatches(
  query: DiscoveryQuery = {},
): readonly QxreadAuthorMatch[] {
  return listAuthorMatches(listCatalog(), toSearchOptions(query));
}
